/* <mw-support-hours>: says whether customer service is open right now, from the opening hours
   the merchant sets (Theme settings › Support: days, open and close hour, time zone), in the
   shop's time zone rather than the visitor's. Open: «Åbent nu · vi er her til kl. 16». Closed:
   «Lukket nu · vi er tilbage i morgen kl. 9». The server-rendered text (the plain opening hours)
   stays when JS is off. Re-checks every minute, so a page left open turns over at closing time.
   Markup: snippets/support-hours.liquid. Styling belongs to the section that shows it. */
(() => {
  if (customElements.get('mw-support-hours')) return;

  const ISO = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

  class MwSupportHours extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('[data-hours-text]') || this;
      this.render();
      this.timer = setInterval(() => this.render(), 60000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    // Weekday (1–7) and decimal hour now, in the shop's time zone.
    clock(date) {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: this.dataset.tz || undefined,
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: 'h23',
      }).formatToParts(date);
      const get = (t) => parts.find((p) => p.type === t)?.value;
      return { day: ISO[get('weekday')], hour: Number(get('hour')) + Number(get('minute')) / 60 };
    }

    render() {
      const days = (this.dataset.days || '1-5').split('-').map(Number);
      const isOpenDay = (d) => d >= days[0] && d <= (days[1] || days[0]);
      const open = Number(this.dataset.open);
      const close = Number(this.dataset.close);
      if (!(close > open)) return;
      const now = new Date();
      const { day, hour } = this.clock(now);
      const lang = document.documentElement.lang || undefined;
      const hh = (h) => String(h);

      if (isOpenDay(day) && hour >= open && hour < close) {
        this.dataset.state = 'open';
        this.text.textContent = this.dataset.openText.replace('%CLOSE%', hh(close));
        return;
      }
      // Next opening: later today, or the first open day after today.
      let ahead = isOpenDay(day) && hour < open ? 0 : 1;
      while (ahead < 8 && !isOpenDay(((day - 1 + ahead) % 7) + 1)) ahead++;
      let label;
      if (ahead === 0) label = this.dataset.today;
      else if (ahead === 1) label = this.dataset.tomorrow;
      else
        label = new Intl.DateTimeFormat(lang, { weekday: 'long', timeZone: this.dataset.tz || undefined }).format(
          new Date(now.getTime() + ahead * 86400000)
        );
      this.dataset.state = 'closed';
      this.text.textContent = this.dataset.closedText.replace('%DAY%', label).replace('%OPEN%', hh(open));
    }
  }

  customElements.define('mw-support-hours', MwSupportHours);
})();
